import Glide from '@glidejs/glide';

document.addEventListener("DOMContentLoaded", () => {
  for (const cls of ["glide-ministry-center", "glide-resources"]) {
	new Glide(`.${cls}`, {
      type: "carousel",
      perView: 1,
      gap: 20,
	}).mount();
  }

  // Select only elements that explicitly request Glide
  const glideEls = document.querySelectorAll("[data-glide-mobile]");
  if (!glideEls.length) return;

  glideEls.forEach((el) => {
    // Prevent duplicate mounting
    if (el.dataset.glideMounted === "true") return;

    const type = el.dataset.type || "carousel";
    const perView = parseInt(el.dataset.perView) || 1;
    const gap = parseInt(el.dataset.gap) || 0;
    const breakpoint = parseInt(el.dataset.breakpoint) || null;

    let glideInstance = null;

    function mount() {
      if (glideInstance) return;
      glideInstance = new Glide(el, { type, perView, gap });
      glideInstance.mount();
      el.dataset.glideMounted = "true";
    }

    function destroy() {
      if (!glideInstance) return;
      glideInstance.destroy();
      glideInstance = null;
      el.dataset.glideMounted = "false";
    }

    // If no breakpoint set → always on
    if (!breakpoint) {
      mount();
      return;
    }

    // Breakpoint logic
    const mq = window.matchMedia(`(max-width: ${breakpoint}px)`);

    function handle(e) {
      e.matches ? mount() : destroy();
    }

    handle(mq);
    mq.addEventListener("change", handle);
  });
});
